enum ExploreUrlParamKey {
  Availability = "availability",
  AvailabilitySet = "availabilitySet",
  Categories = "categories",
  ContentType = "contentType",
  Currency = "currency",
  Decimals = "decimals",
  HasPnft = "hasPnft",
  HasUnlockable = "hasUnlockable",
  NftKindSet = "nftKindSet",
  PriceHigh = "priceHigh",
  PriceLow = "priceLow",
  PrimaryMarket = "primaryMarket",
  SecondaryMarket = "secondaryMarket",
  SortOrderArtwork = "sortOrderArtwork",
  SortOrderCampaigns = "sortOrderCampaigns",
  SortOrderCreators = "sortOrderCreators",
  SortOrderEditions = "sortOrderEditions",
  SortOrderSeries = "sortOrderSeries",
  Tab = "tab",
}

export default ExploreUrlParamKey;
